function importModule (url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    const tempGlobal = '__tempModuleLoadingVariable' + Math.random().toString(32).substring(2)
    function cleanUp () {
      delete window[tempGlobal]
      delete window[tempGlobal + '_success']
      delete window[tempGlobal + '_error']
      script.remove()
    }

    window[tempGlobal + '_success'] = (m) => { resolve(m?.default || m); cleanUp() }

    script.type = 'module'
    script.crossorigin = 'use-credentials'
    script.crossOrigin = 'use-credentials'

    script.textContent = `import * as m from "${url}"; window.${tempGlobal} = m; window.${tempGlobal + '_success'}(m)`

    script.addEventListener('load', cleanUp)
    script.addEventListener('error', cleanUp)

    document.documentElement.appendChild(script)
  })
}

export default function loadModule (name, refresh = false) {
  let url
  if (window?.__polystack_data__?.assignmentVersionId) {
    url = `/_build/components/${name}.js`
  } else {
    url = `/admin/packgr/${name}/dist/bundle.js`
  }
  if (refresh) url += `?ts=${new Date().getTime()}`
  return importModule(url)
}
